<template>
    <div>
        <el-dialog
            title="发放动态皮肤"
            :visible.sync="dialogDtSkinVisible"
            :append-to-body="true"
            width="400px"
            :center="true"
            top="200px"
            :close-on-click-modal="false"
            :before-close="() => closeDtSkinDialog()"
        >
            <el-form
                :model="DtSkinForm"
                :rules="rules"
                ref="DtSkinForm"
                label-width="100px"
            >
                <el-form-item label="选择皮肤" prop="dt_skin_id">
                    <el-select v-model="DtSkinForm.dt_skin_id" placeholder="请选择皮肤" filterable clearable @change="get_img" class="dt_skin_c">
                        <el-option
                            v-for="item in dt_skin_arr"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="text-align: center;"><img :src="img" height="200px" v-if="img" style="border-radius: 10px;"></div>
            <div slot="footer">
                <el-button type="success" plain @click="submit('DtSkinForm')" >发 放</el-button>
                <el-button plain @click="closeDtSkinDialog()">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { UserGiveDtSkinRequest } from '@/network/user.js'
import { ShopSkinDtListRequest,ShopSkinDtDetailsRequest } from '@/network/shop/ShopSkinDt.js'

export default {
    name:'',
    data(){
        return {
            DtSkinForm: {
                dt_skin_id: ''
            },
            rules: {
                dt_skin_id: [
                    {
                        required: true,
                        message: '请选择皮肤',
                        trigger: 'blur',
                    },
                ]
            },
            dt_skin_arr: [],
            img: ''
        }
    },
    computed:{},
    methods:{
        closeDtSkinDialog() {
            this.DtSkinForm = {
                dt_skin_id: ''
            }
            this.img = ''
            this.$emit('ExitDtSkinDialog')
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }

                this.DtSkinForm.user_id = this.id
                UserGiveDtSkinRequest(this.DtSkinForm)
                    .then((s) => {
                        if (s.status === 0) {
                            this.$message.success('皮肤发放成功!')
                            this.$emit('refresh')
                            this.closeDtSkinDialog()
                        } else {
                            this.$message.error(s.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            })
        },
        get_all_dt_skin() {
            ShopSkinDtListRequest()
                .then((s) => {
                    if (s.status === 0) {
                        this.dt_skin_arr = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        },
        get_img(v) {
            if(v) {
                ShopSkinDtDetailsRequest(v)
                .then((s) => {
                    if (s.status === 0) {
                        this.img = s.result.data.picture[0]['url']
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            }

            this.img = ''
        }
    },
    filters:{},
    props:{
        dialogDtSkinVisible: {
            type: Boolean,
            default() {
                return false
            }
        },
        id: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    created(){
        this.get_all_dt_skin()
    },
    beforeDestroy(){},
    mounted(){},
    updated(){},
    components:{},
    watch:{}
}
</script>

<style lang='less' scoped>
</style>